<template>
  <base-draggable-card-view
    v-model:force-maximize="forceMaximize"
    v-model:maximized="maximized"
    card-type="bottom"
    x-init-pos="10px"
    class="guide-properties-container"
  >
    <template #toolbarContent
      ><div
        :style="maximized ? undefined : 'text-overflow: ellipsis; white-space: nowrap; overflow: hidden'"
        class="mr-2"
      >
        {{ titleText }}
      </div></template
    >
    <template #content="scope"
      ><v-divider thickness="1"></v-divider>
      <properties-container
        :model="model"
        :show="scope.show"
        @update:title-text="
          (newTitle: string) => {
            titleText = newTitle;
          }
        "
      ></properties-container
    ></template>
  </base-draggable-card-view>
</template>

<script setup lang="ts">
import { TourEventBus, UIEventBus } from "../../event-bus";
import RappidContext from "../rappid/rappid-context";
import { getStatechart } from "../services/model-helper";
import { dia } from "@clientio/rappid";
import { inject, ref, onMounted, onBeforeUnmount } from "vue";
import BaseDraggableCardView from "../../shared/BaseDraggableCardView.vue";
import PropertiesContainer from "./PropertiesContainer.vue";
import { NodeLabel } from "../mvc/base/labeled-node";
import { activeView } from "../subdiagram-viewer";

const rappidContext: RappidContext = inject<RappidContext>("rappidContext");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const model = ref<any>();

const titleText = ref<string>("");

const forceMaximize = ref<boolean>(false);
const maximized = ref<boolean>(false);

function forceMaximizeHandler() {
  forceMaximize.value = true;
}

onMounted(() => {
  rappidContext.graph.on("remove", (cell) => {
    if (cell?.cid === model.value?.cid) {
      model.value = null;
    }
  });

  rappidContext.graph.on("add", () => {
    model.value = null;
  });

  UIEventBus.on("cellSelectionChanged", setModel);
  TourEventBus.on("startOnboarding", forceMaximizeHandler);
});

onBeforeUnmount(() => {
  UIEventBus.off("cellSelectionChanged", setModel);
  TourEventBus.off("startOnboarding", forceMaximizeHandler);
});

function setModel(selection: joint.mvc.Collection<dia.Cell>) {
  if (selection.length === 0) {
    model.value = activeView.value?.model ?? getStatechart(rappidContext.paper.model);
  } else if (selection.length === 1) {
    const element = selection.first();
    model.value = element instanceof NodeLabel ? (element.getParentCell() ?? element) : element;
  }
}
</script>

<style>
.draggable-flex {
  display: inherit;
  flex-direction: inherit;
}
</style>
